import { PutStaff, GetStaff, CheckStaffTel, StaffRecharge, BatchStaff, BatchStaffPWD , GetStaffRechargeList, StaffRechargeData,BatchStaffInsert} from '@/api/staff'
export default {
  state: {

  },
  getters: {

  },
  actions: {
    PutStaff ({ commit }, payload) {
      return new Promise(resolve => {
        PutStaff(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    GetStaff ({ commit }, payload) {
      return new Promise(resolve => {
        GetStaff(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    CheckStaffTel ({ commit }, payload) {
      return new Promise(resolve => {
        CheckStaffTel(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    StaffRecharge ({ commit }, payload) {
      return new Promise(resolve => {
        StaffRecharge(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    BatchStaff({commit},payload){
      return new Promise(resolve => {
        BatchStaff(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    BatchStaffPWD({commit},payload){
      return new Promise(resolve => {
        BatchStaffPWD(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    GetStaffRechargeList({commit},payload){
      return new Promise(resolve => {
        GetStaffRechargeList(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    BatchStaffInsert({commit},payload){
      return new Promise(resolve => {
        BatchStaffInsert(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    StaffRechargeData({commit},payload){
      return new Promise(resolve => {
        StaffRechargeData(payload).then(res => {
          resolve(res.data)
        })
      })
    }

  },
  mutations: {

  }
}
